import React from 'react'
import useLocalize from 'localize/useLocalize'

const withLocalizeText = WrappedComponent => props => {
  const { localize } = useLocalize()
  return <WrappedComponent {...props} localize={localize} />
}

export default withLocalizeText
